/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CartDeleteInput = {
    readonly id: string;
    readonly productId: string;
    readonly clientMutationId?: string | null;
};
export type CartDeleteMutationVariables = {
    readonly input: CartDeleteInput;
};
export type CartDeleteMutationResponse = {
    readonly cartDelete: ({
        readonly deletedCartEntryId: string | null;
        readonly cart: ({
            readonly id: string;
            readonly eventId: string | null;
            readonly event: ({
                readonly id: string;
                readonly trinityPartyType: string | null;
            }) | null;
            readonly taxRate: number | null;
            readonly taxTotal: number | null;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly enrollingAsPc: boolean | null;
            readonly totalNumberOfItems: number | null;
            readonly viaQualifiedCartTotal: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly subTotalPriceOfItemsWithPromoCodes: number | null;
            readonly entries: ({
                readonly edges: ReadonlyArray<({
                    readonly node: ({
                        readonly id: string;
                        readonly quantity: number | null;
                        readonly product: ({
                            readonly id: string;
                            readonly name: string | null;
                            readonly price: number | null;
                            readonly priceSale: number | null;
                            readonly productId: string | null;
                            readonly productPermissions: ({
                                readonly oneCommerce: ({
                                    readonly preferredCustomer: ({
                                        readonly add: boolean | null;
                                    }) | null;
                                }) | null;
                            }) | null;
                            readonly images: ({
                                readonly squareFront: string | null;
                                readonly productCatalog: string | null;
                                readonly productFront: string | null;
                                readonly productBack: string | null;
                            }) | null;
                            readonly promoCodeDiscount: ({
                                readonly case4Cause: ({
                                    readonly case6SKU: string | null;
                                    readonly case12SKU: string | null;
                                    readonly donationEligible: boolean | null;
                                    readonly case12PriceUSD: number | null;
                                    readonly case6PriceUSD: number | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null;
                }) | null> | null;
            }) | null;
            readonly entriesV2: ({
                readonly edges: ReadonlyArray<({
                    readonly node: ({
                        readonly id: string;
                        readonly quantity: number | null;
                        readonly product: ({
                            readonly name: string | null;
                            readonly id: string;
                            readonly productId: string | null;
                            readonly price: number | null;
                            readonly finalPrice: number | null;
                            readonly productPermissions: ({
                                readonly oneCommerce: ({
                                    readonly preferredCustomer: ({
                                        readonly add: boolean | null;
                                    }) | null;
                                }) | null;
                            }) | null;
                            readonly images: ({
                                readonly squareFront: string | null;
                                readonly productCatalog: string | null;
                                readonly productFront: string | null;
                                readonly productBack: string | null;
                            }) | null;
                            readonly promoCodeDiscount: ({
                                readonly case4Cause: ({
                                    readonly case6SKU: string | null;
                                    readonly case12SKU: string | null;
                                    readonly donationEligible: boolean | null;
                                    readonly case12PriceUSD: number | null;
                                    readonly case6PriceUSD: number | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null;
                }) | null> | null;
            }) | null;
            readonly pcPotentialSavings: ReadonlyArray<number | null> | null;
            readonly promoCodeSavings: number | null;
            readonly promoCodeDiscountedItems: ReadonlyArray<({
                readonly id: string;
                readonly nonDiscountedSkus: ({
                    readonly edges: ReadonlyArray<({
                        readonly node: ({
                            readonly id: string;
                            readonly sku: string | null;
                            readonly discountAmount: number | null;
                            readonly productId: string | null;
                            readonly quantity: number | null;
                            readonly product: ({
                                readonly id: string;
                                readonly productId: string | null;
                                readonly productURLslug: string | null;
                                readonly name: string | null;
                                readonly price: number | null;
                                readonly productPermissions: ({
                                    readonly oneCommerce: ({
                                        readonly preferredCustomer: ({
                                            readonly add: boolean | null;
                                        }) | null;
                                    }) | null;
                                }) | null;
                                readonly images: ({
                                    readonly squareFront: string | null;
                                    readonly productCatalog: string | null;
                                    readonly productFront: string | null;
                                    readonly productBack: string | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null> | null;
                }) | null;
                readonly discountedSkus: ({
                    readonly edges: ReadonlyArray<({
                        readonly node: ({
                            readonly id: string;
                            readonly sku: string | null;
                            readonly discountAmount: number | null;
                            readonly productId: string | null;
                            readonly quantity: number | null;
                            readonly product: ({
                                readonly id: string;
                                readonly productId: string | null;
                                readonly productURLslug: string | null;
                                readonly name: string | null;
                                readonly price: number | null;
                                readonly productPermissions: ({
                                    readonly oneCommerce: ({
                                        readonly preferredCustomer: ({
                                            readonly add: boolean | null;
                                        }) | null;
                                    }) | null;
                                }) | null;
                                readonly images: ({
                                    readonly squareFront: string | null;
                                    readonly productCatalog: string | null;
                                    readonly productFront: string | null;
                                    readonly productBack: string | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null> | null;
                }) | null;
            }) | null> | null;
        }) | null;
    }) | null;
};
export type CartDeleteMutation = {
    readonly response: CartDeleteMutationResponse;
    readonly variables: CartDeleteMutationVariables;
};



/*
mutation CartDeleteMutation(
  $input: CartDeleteInput!
) {
  cartDelete(input: $input) {
    deletedCartEntryId
    cart {
      id
      eventId
      event {
        id
        trinityPartyType
      }
      taxRate
      taxTotal
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      enrollingAsPc
      totalNumberOfItems
      viaQualifiedCartTotal
      subTotalPriceOfItems
      subTotalPriceOfItemsWithPromoCodes
      entries(first: 1000) {
        edges {
          node {
            id
            quantity
            product {
              id
              name
              price
              priceSale
              productId
              productPermissions {
                oneCommerce {
                  preferredCustomer {
                    add
                  }
                }
              }
              images {
                squareFront
                productCatalog
                productFront
                productBack
                id
              }
              promoCodeDiscount {
                case4Cause {
                  case6SKU
                  case12SKU
                  donationEligible
                  case12PriceUSD
                  case6PriceUSD
                }
              }
            }
          }
        }
      }
      entriesV2(first: 1000) {
        edges {
          node {
            id
            quantity
            product {
              name
              id
              productId
              price
              finalPrice
              productPermissions {
                oneCommerce {
                  preferredCustomer {
                    add
                  }
                }
              }
              images {
                squareFront
                productCatalog
                productFront
                productBack
                id
              }
              promoCodeDiscount {
                case4Cause {
                  case6SKU
                  case12SKU
                  donationEligible
                  case12PriceUSD
                  case6PriceUSD
                }
              }
            }
          }
        }
      }
      pcPotentialSavings
      promoCodeSavings
      promoCodeDiscountedItems {
        id
        nonDiscountedSkus {
          edges {
            node {
              id
              sku
              discountAmount
              productId
              quantity
              product {
                id
                productId
                productURLslug
                name
                price
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                images {
                  squareFront
                  productCatalog
                  productFront
                  productBack
                  id
                }
              }
            }
          }
        }
        discountedSkus {
          edges {
            node {
              id
              sku
              discountAmount
              productId
              quantity
              product {
                id
                productId
                productURLslug
                name
                price
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                images {
                  squareFront
                  productCatalog
                  productFront
                  productBack
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartDeleteInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CartDeleteInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedCartEntryId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfItems",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "trinityPartyType",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "taxRate",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "taxTotal",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipEnabled",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalUnit",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalCount",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrollingAsPc",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "viaQualifiedCartTotal",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItemsWithPromoCodes",
        "args": null,
        "storageKey": null
    } as any), v16 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1000,
            "type": "Int"
        } as any)
    ], v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "productPermissions",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductPermissions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "AppProductPermissionsAccess",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductPermissionsAccess",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "add",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "squareFront",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productCatalog",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productFront",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productBack",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "images",
        "storageKey": null,
        "args": null,
        "concreteType": "Images",
        "plural": false,
        "selections": [
            (v23 /*: any*/),
            (v24 /*: any*/),
            (v25 /*: any*/),
            (v26 /*: any*/)
        ]
    } as any), v28 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscount",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case4Cause",
                "storageKey": null,
                "args": null,
                "concreteType": "Case4Cause",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "donationEligible",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6PriceUSD",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "finalPrice",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pcPotentialSavings",
        "args": null,
        "storageKey": null
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sku",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "discountAmount",
        "args": null,
        "storageKey": null
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v35 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeItemDiscountEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PromoCodeItemDiscountTuple",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v32 /*: any*/),
                        (v33 /*: any*/),
                        (v21 /*: any*/),
                        (v17 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v21 /*: any*/),
                                (v34 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v22 /*: any*/),
                                (v27 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ], v36 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "images",
        "storageKey": null,
        "args": null,
        "concreteType": "Images",
        "plural": false,
        "selections": [
            (v23 /*: any*/),
            (v24 /*: any*/),
            (v25 /*: any*/),
            (v26 /*: any*/),
            (v4 /*: any*/)
        ]
    } as any), v37 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeItemDiscountEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PromoCodeItemDiscountTuple",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v32 /*: any*/),
                        (v33 /*: any*/),
                        (v21 /*: any*/),
                        (v17 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v21 /*: any*/),
                                (v34 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v22 /*: any*/),
                                (v36 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartDeleteMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartDelete",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartDeletePayload",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entries",
                                    "storageKey": "entries(first:1000)",
                                    "args": (v16 /*: any*/),
                                    "concreteType": "CartEntryV3Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV3Edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Product",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v22 /*: any*/),
                                                                (v27 /*: any*/),
                                                                (v28 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entriesV2",
                                    "storageKey": "entriesV2(first:1000)",
                                    "args": (v16 /*: any*/),
                                    "concreteType": "CartEntryV2Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV2Edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v22 /*: any*/),
                                                                (v27 /*: any*/),
                                                                (v28 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v30 /*: any*/),
                                (v31 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodeDiscountedItems",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCodeDiscountItem",
                                    "plural": true,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "nonDiscountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v35 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "discountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v35 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartDeleteMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartDelete",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartDeletePayload",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entries",
                                    "storageKey": "entries(first:1000)",
                                    "args": (v16 /*: any*/),
                                    "concreteType": "CartEntryV3Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV3Edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Product",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v22 /*: any*/),
                                                                (v36 /*: any*/),
                                                                (v28 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entriesV2",
                                    "storageKey": "entriesV2(first:1000)",
                                    "args": (v16 /*: any*/),
                                    "concreteType": "CartEntryV2Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV2Edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v22 /*: any*/),
                                                                (v36 /*: any*/),
                                                                (v28 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v30 /*: any*/),
                                (v31 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodeDiscountedItems",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCodeDiscountItem",
                                    "plural": true,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "nonDiscountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v37 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "discountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v37 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartDeleteMutation",
            "id": null,
            "text": "mutation CartDeleteMutation(\n  $input: CartDeleteInput!\n) {\n  cartDelete(input: $input) {\n    deletedCartEntryId\n    cart {\n      id\n      eventId\n      event {\n        id\n        trinityPartyType\n      }\n      taxRate\n      taxTotal\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      enrollingAsPc\n      totalNumberOfItems\n      viaQualifiedCartTotal\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithPromoCodes\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            quantity\n            product {\n              id\n              name\n              price\n              priceSale\n              productId\n              productPermissions {\n                oneCommerce {\n                  preferredCustomer {\n                    add\n                  }\n                }\n              }\n              images {\n                squareFront\n                productCatalog\n                productFront\n                productBack\n                id\n              }\n              promoCodeDiscount {\n                case4Cause {\n                  case6SKU\n                  case12SKU\n                  donationEligible\n                  case12PriceUSD\n                  case6PriceUSD\n                }\n              }\n            }\n          }\n        }\n      }\n      entriesV2(first: 1000) {\n        edges {\n          node {\n            id\n            quantity\n            product {\n              name\n              id\n              productId\n              price\n              finalPrice\n              productPermissions {\n                oneCommerce {\n                  preferredCustomer {\n                    add\n                  }\n                }\n              }\n              images {\n                squareFront\n                productCatalog\n                productFront\n                productBack\n                id\n              }\n              promoCodeDiscount {\n                case4Cause {\n                  case6SKU\n                  case12SKU\n                  donationEligible\n                  case12PriceUSD\n                  case6PriceUSD\n                }\n              }\n            }\n          }\n        }\n      }\n      pcPotentialSavings\n      promoCodeSavings\n      promoCodeDiscountedItems {\n        id\n        nonDiscountedSkus {\n          edges {\n            node {\n              id\n              sku\n              discountAmount\n              productId\n              quantity\n              product {\n                id\n                productId\n                productURLslug\n                name\n                price\n                productPermissions {\n                  oneCommerce {\n                    preferredCustomer {\n                      add\n                    }\n                  }\n                }\n                images {\n                  squareFront\n                  productCatalog\n                  productFront\n                  productBack\n                  id\n                }\n              }\n            }\n          }\n        }\n        discountedSkus {\n          edges {\n            node {\n              id\n              sku\n              discountAmount\n              productId\n              quantity\n              product {\n                id\n                productId\n                productURLslug\n                name\n                price\n                productPermissions {\n                  oneCommerce {\n                    preferredCustomer {\n                      add\n                    }\n                  }\n                }\n                images {\n                  squareFront\n                  productCatalog\n                  productFront\n                  productBack\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c7bada6ab197a8bcafffb6fa5341997a';
export default node;
